interface TableColumn {
  key: string;
  header: string;
  searchable?: boolean;
  filterable?: boolean;
}
export const MerchantColumns: TableColumn[] = [
  { key: "promoImage", header: "Logo" },
  { key: "unit_number", header: "Unit Number" },
  { key: "zone", header: "Zone" },
  { key: "merchant_name", header: "Merchant" },
  { key: "companyName", header: "Company Name" },

  {
    key: "directorySubCategory",
    header: "Directory SubCategory",
  },
  { key: "acceptsVoucher", header: "Accepts Vouchers" },

  { key: "payWithPoints", header: "Earn Points" },

  { key: "partner", header: "Partner" },

  { key: "status", header: "Status" },
];

export const merchantMetaData = {
  promoImage: {
    isImage: true,
    linkTo: "",
  },
  storeName: {
    isImage: false,
    linkTo: "",
  },
  companyName: {
    isImage: false,
    linkTo: "",
  },
  directoryCategory: {
    isImage: false,
    linkTo: "",
  },
  directorySubCategory: {
    isImage: false,
    linkTo: "",
  },
  towerNumber: {
    isImage: false,
    linkTo: "",
  },
  zone: {
    isImage: false,
    linkTo: "",
  },
  leaseID: {
    isImage: false,
    linkTo: "",
  },
  isSponsored: {
    isImage: false,
    linkTo: "",
  },
  acceptsVoucher: {
    isImage: false,
    linkTo: "",
  },
  earnPoints: {
    isImage: false,
    linkTo: "",
  },
  hideFromDirectory: {
    isImage: false,
    linkTo: "",
  },
  payWithPoints: {
    isImage: false,
    linkTo: "",
  },
  halalCertifed: {
    isImage: false,
    linkTo: "",
  },
  status: {
    isImage: false,
    linkTo: "",
  },
};
